import React from "react";

export default function ServiceItems({ icon, title, desc }) {
  return (
    <>
      <div className="col-md-4 mb-3">
        <div className="d-flex gap-3">
          <img src={icon} alt="" width={"40px"} />
          <div>
            <h4 className="brown-color">{title}</h4>
            <p>{desc}</p>
          </div>
        </div>
      </div>
    </>
  );
}
